/* eslint-disable */
// src/services/refreshSessionService.js

import axios from "services/axiosConfig";

const REFRESH_SESSIONS_URL = "/api/refresh-sessions";

class RefreshSessionService {
  static async getRefreshSessions() {
    const { data } = await axios.get(REFRESH_SESSIONS_URL, {
      params: { _: Date.now() },
    });
    return Array.isArray(data) ? data : [];
  }

  static async revokeRefreshSession(id) {
    const { data } = await axios.patch(`${REFRESH_SESSIONS_URL}/${id}/revoke`, {
      reason: "admin_revoke",
    });
    return data;
  }
}

export default RefreshSessionService;
